import { render, staticRenderFns } from "./accountLiab.vue?vue&type=template&id=7e6a9e63&scoped=true"
import script from "./accountLiab.vue?vue&type=script&lang=js"
export * from "./accountLiab.vue?vue&type=script&lang=js"
import style0 from "./accountLiab.vue?vue&type=style&index=0&id=7e6a9e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6a9e63",
  null
  
)

export default component.exports